<button *ngIf="enable"
        type="button"
        class="manage-tags img-btn"
        genTooltip
        [tooltipHtml]="tooltipText"
        [tooltipPosition]="tooltipPosition"
        [tooltipShow]="true"
        [appendToBody]="true"
        [ngClass]="cssClass"
        [ngStyle]="styleItem"
        [disabled]="isDisabled"
        (click)="manageTags()">
  <span class="icon__Tag"></span>
</button>
